// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1AbZT","content":"LoadingAlert_content__3msW9"};